/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Templates_UploadInputs */

const cs_social_templates_upload = /** @type {(inputs: Social_Templates_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nahrát šablonu`)
};

const en_social_templates_upload = /** @type {(inputs: Social_Templates_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload template`)
};

/**
* | output |
* | --- |
* | "Upload template" |
*
* @param {Social_Templates_UploadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_templates_upload = /** @type {((inputs?: Social_Templates_UploadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Templates_UploadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_templates_upload(inputs)
	return cs_social_templates_upload(inputs)
});